const MembershipBenefitsOverview = () => {
  const membershipComparison = [
    {
      tier: "Prestige",
      price: "$2,500/year",
      color: "luxury-gold-500",
      popular: true,
      benefits: [
        { feature: "Personal Style Consultation", prestige: true, elite: true, signature: true },
        { feature: "Priority Access to Collections", prestige: true, elite: true, signature: true },
        { feature: "Quarterly Styling Sessions", prestige: "2", elite: "4", signature: "Unlimited" },
        { feature: "Exclusive Member Events", prestige: true, elite: true, signature: true },
        { feature: "Dedicated Style Advisor", prestige: false, elite: true, signature: true },
        { feature: "24/7 Concierge Service", prestige: false, elite: false, signature: true },
        { feature: "Private Shopping Appointments", prestige: false, elite: true, signature: true },
        { feature: "Global VIP Access", prestige: false, elite: false, signature: true },
        { feature: "Bespoke Wardrobe Planning", prestige: false, elite: true, signature: true },
        { feature: "Personal Shopper Service", prestige: false, elite: false, signature: true },
        { feature: "Luxury Travel Styling", prestige: false, elite: false, signature: true },
        { feature: "Red Carpet/Event Styling", prestige: false, elite: false, signature: true }
      ]
    }
  ]

  const exclusivePerks = [
    {
      icon: "🎁",
      title: "Welcome Package",
      description: "Luxury gift set with exclusive items curated for new members",
      allTiers: true
    },
    {
      icon: "📱",
      title: "Mobile App Access",
      description: "Dedicated app for styling requests, appointments, and exclusive content",
      allTiers: true
    },
    {
      icon: "🚗",
      title: "Complimentary Services",
      description: "Free alterations, delivery, and returns for all purchases",
      allTiers: true
    },
    {
      icon: "💎",
      title: "Exclusive Collections",
      description: "Early access to limited editions and designer collaborations",
      allTiers: true
    },
    {
      icon: "🌍",
      title: "International Support",
      description: "Global styling services and concierge support while traveling",
      elite: true,
      signature: true
    },
    {
      icon: "👑",
      title: "VIP Experiences",
      description: "Fashion shows, designer meet-and-greets, and private events",
      signature: true
    }
  ]

  const testimonials = [
    {
      name: "Isabella Chen",
      tier: "Signature Member",
      quote: "FGA Prestige has completely transformed my approach to fashion. The personalized service is unmatched.",
      image: "/images/testimonial-1.jpg"
    },
    {
      name: "Marcus Williams",
      tier: "Elite Member", 
      quote: "The styling expertise and attention to detail have elevated my professional image significantly.",
      image: "/images/testimonial-2.jpg"
    },
    {
      name: "Sophia Laurent",
      tier: "Prestige Member",
      quote: "Finally, a service that understands luxury fashion and delivers exceptional experiences every time.",
      image: "/images/testimonial-3.jpg"
    }
  ]

  return (
    <section className="py-20 bg-white">
      <div className="container-luxury">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="luxury-heading text-3xl md:text-4xl mb-6 text-luxury-black-950">
            Membership Benefits
          </h2>
          <p className="luxury-body text-lg text-luxury-black-600 max-w-2xl mx-auto">
            Discover the exclusive benefits and privileges that come with your FGA Prestige membership.
          </p>
        </div>

        {/* Benefits Comparison Table */}
        <div className="mb-20">
          <div className="overflow-x-auto">
            <table className="w-full bg-white shadow-luxury">
              <thead>
                <tr className="bg-luxury-cream-50">
                  <th className="text-left p-6 luxury-subheading text-lg text-luxury-black-950">
                    Benefits & Services
                  </th>
                  <th className="text-center p-6 luxury-subheading text-lg text-luxury-black-950">
                    <div>Prestige</div>
                    <div className="text-sm font-normal text-luxury-gold-600">$2,500/year</div>
                  </th>
                  <th className="text-center p-6 luxury-subheading text-lg text-luxury-black-950">
                    <div>Elite</div>
                    <div className="text-sm font-normal text-luxury-gold-600">$5,000/year</div>
                  </th>
                  <th className="text-center p-6 luxury-subheading text-lg text-luxury-black-950 relative">
                    <div>Signature</div>
                    <div className="text-sm font-normal text-luxury-gold-600">$10,000/year</div>
                    <div className="absolute -top-2 -right-2 bg-luxury-gold-500 text-luxury-black-950 text-xs px-2 py-1 uppercase tracking-wider font-bold">
                      Ultimate
                    </div>
                  </th>
                </tr>
              </thead>
              <tbody>
                {membershipComparison[0].benefits.map((benefit, index) => (
                  <tr key={index} className={index % 2 === 0 ? 'bg-luxury-cream-25' : 'bg-white'}>
                    <td className="p-4 luxury-body text-luxury-black-700 font-medium">
                      {benefit.feature}
                    </td>
                    <td className="p-4 text-center">
                      {typeof benefit.prestige === 'boolean' ? (
                        benefit.prestige ? (
                          <span className="text-luxury-gold-600 text-xl">✓</span>
                        ) : (
                          <span className="text-luxury-black-300 text-xl">-</span>
                        )
                      ) : (
                        <span className="text-luxury-black-700 font-medium">{benefit.prestige}</span>
                      )}
                    </td>
                    <td className="p-4 text-center">
                      {typeof benefit.elite === 'boolean' ? (
                        benefit.elite ? (
                          <span className="text-luxury-gold-600 text-xl">✓</span>
                        ) : (
                          <span className="text-luxury-black-300 text-xl">-</span>
                        )
                      ) : (
                        <span className="text-luxury-black-700 font-medium">{benefit.elite}</span>
                      )}
                    </td>
                    <td className="p-4 text-center">
                      {typeof benefit.signature === 'boolean' ? (
                        benefit.signature ? (
                          <span className="text-luxury-gold-600 text-xl">✓</span>
                        ) : (
                          <span className="text-luxury-black-300 text-xl">-</span>
                        )
                      ) : (
                        <span className="text-luxury-black-700 font-medium">{benefit.signature}</span>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

        {/* Exclusive Perks */}
        <div className="mb-20">
          <h3 className="luxury-heading text-2xl text-center mb-12 text-luxury-black-950">
            Exclusive Member Perks
          </h3>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {exclusivePerks.map((perk, index) => (
              <div key={index} className="bg-luxury-cream-50 p-6 text-center hover:shadow-luxury transition-shadow duration-300">
                <div className="text-4xl mb-4">{perk.icon}</div>
                <h4 className="luxury-subheading text-lg mb-3 text-luxury-black-950">
                  {perk.title}
                </h4>
                <p className="luxury-body text-sm text-luxury-black-600 mb-4">
                  {perk.description}
                </p>
                
                <div className="text-xs uppercase tracking-wider">
                  {perk.allTiers && (
                    <span className="bg-luxury-gold-500 text-luxury-black-950 px-2 py-1 mr-1">
                      All Tiers
                    </span>
                  )}
                  {perk.elite && !perk.allTiers && (
                    <span className="bg-luxury-black-700 text-white px-2 py-1 mr-1">
                      Elite+
                    </span>
                  )}
                  {perk.signature && !perk.elite && !perk.allTiers && (
                    <span className="bg-luxury-black-950 text-luxury-gold-400 px-2 py-1">
                      Signature Only
                    </span>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Member Testimonials */}
        <div className="bg-luxury-black-950 text-white p-8 md:p-12 mb-20">
          <h3 className="luxury-heading text-2xl text-center mb-12 text-white">
            What Our Members Say
          </h3>
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {testimonials.map((testimonial, index) => (
              <div key={index} className="bg-luxury-black-900 p-6 border border-luxury-gold-500/20">
                <div className="flex items-center mb-4">
                  <div 
                    className="w-12 h-12 bg-luxury-gold-500/20 rounded-full mr-4"
                    style={{
                      backgroundImage: `url(${testimonial.image})`,
                      backgroundSize: 'cover',
                      backgroundPosition: 'center'
                    }}
                  />
                  <div>
                    <div className="luxury-subheading text-lg text-white">{testimonial.name}</div>
                    <div className="text-sm text-luxury-gold-400">{testimonial.tier}</div>
                  </div>
                </div>
                
                <blockquote className="luxury-body text-luxury-cream-100 italic leading-relaxed">
                  "{testimonial.quote}"
                </blockquote>
                
                <div className="flex text-luxury-gold-400 mt-4">
                  {[...Array(5)].map((_, i) => (
                    <span key={i}>⭐</span>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Membership Value Proposition */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center mb-16">
          <div>
            <h3 className="luxury-heading text-2xl mb-6 text-luxury-black-950">
              Investment in Excellence
            </h3>
            <p className="luxury-body text-luxury-black-600 mb-6 leading-relaxed">
              Your FGA Prestige membership is more than a service—it's an investment in your 
              personal brand, confidence, and lifestyle. Our members save an average of 
              30+ hours per year while achieving a more sophisticated, polished appearance.
            </p>
            
            <div className="space-y-4">
              <div className="flex items-center space-x-3">
                <div className="w-6 h-6 bg-luxury-gold-500 rounded-full flex items-center justify-center">
                  <span className="text-luxury-black-950 text-sm">✓</span>
                </div>
                <span className="luxury-body text-luxury-black-700">
                  Average annual styling savings: $3,000+
                </span>
              </div>
              
              <div className="flex items-center space-x-3">
                <div className="w-6 h-6 bg-luxury-gold-500 rounded-full flex items-center justify-center">
                  <span className="text-luxury-black-950 text-sm">✓</span>
                </div>
                <span className="luxury-body text-luxury-black-700">
                  Time saved on shopping and styling: 30+ hours/year
                </span>
              </div>
              
              <div className="flex items-center space-x-3">
                <div className="w-6 h-6 bg-luxury-gold-500 rounded-full flex items-center justify-center">
                  <span className="text-luxury-black-950 text-sm">✓</span>
                </div>
                <span className="luxury-body text-luxury-black-700">
                  Exclusive access to limited collections and events
                </span>
              </div>
            </div>
          </div>
          
          <div className="bg-luxury-cream-50 p-8">
            <h4 className="luxury-subheading text-xl mb-6 text-luxury-black-950">
              Membership ROI Calculator
            </h4>
            
            <div className="space-y-4 text-sm">
              <div className="flex justify-between">
                <span className="text-luxury-black-600">Personal Shopping Time Saved:</span>
                <span className="font-medium text-luxury-black-950">$1,500</span>
              </div>
              
              <div className="flex justify-between">
                <span className="text-luxury-black-600">Professional Styling Sessions:</span>
                <span className="font-medium text-luxury-black-950">$2,000</span>
              </div>
              
              <div className="flex justify-between">
                <span className="text-luxury-black-600">Exclusive Access Value:</span>
                <span className="font-medium text-luxury-black-950">$1,000</span>
              </div>
              
              <div className="flex justify-between">
                <span className="text-luxury-black-600">Concierge Services:</span>
                <span className="font-medium text-luxury-black-950">$800</span>
              </div>
              
              <div className="border-t border-luxury-black-200 pt-2 flex justify-between">
                <span className="font-medium text-luxury-black-950">Total Annual Value:</span>
                <span className="font-bold text-luxury-gold-600">$5,300+</span>
              </div>
            </div>
          </div>
        </div>

        {/* Final CTA */}
        <div className="text-center">
          <h3 className="luxury-heading text-2xl mb-4 text-luxury-black-950">
            Ready to Elevate Your Style?
          </h3>
          <p className="luxury-body text-luxury-black-600 mb-8 max-w-2xl mx-auto">
            Join thousands of discerning individuals who trust FGA Prestige with their 
            luxury fashion needs. Start your application today.
          </p>
          <a
            to="#application-form"
            className="btn-luxury-primary"
          >
            Begin Your Application
          </a>
        </div>
      </div>
    </section>
  )
}

export default MembershipBenefitsOverview